const state = {
  currentCampaign: null,
  previousCampaign: null,
  distributor: null,
  state: null,
  crop: null,
  variety: null,
  month: null,
};

const getters = {
  getPreviousCampaign: (state) => {
    return state.previousCampaign;
  },
};

const actions = {
  setCurrentCampaign(context, value) {
    context.commit('SET_CURRENT_CAMPAIGN', value);
  },

  setPreviousCampaign(context, value) {
    context.commit('SET_PREVIOUS_CAMPAIGN', value);
  },

  setDistributor(context, value) {
    context.commit('SET_DISTRIBUTOR', value);
  },

  setState(context, value) {
    context.commit('SET_STATE', value);
  },

  setCrop(context, value) {
    context.commit('SET_CROP', value);
  },

  setVariety(context, value) {
    context.commit('SET_VARIETY', value);
  },

  setMonth(context, value) {
    context.commit('SET_MONTH', value);
  },

  clearChartFilters(context) {
    context.dispatch('setCurrentCampaign', null);
    context.dispatch('setPreviousCampaign', null);
    context.dispatch('setDistributor', null);
    context.dispatch('setState', null);
    context.dispatch('setCrop', null);
    context.dispatch('setVariety', null);
    context.dispatch('setMonth', null);
  },
};

const mutations = {
  SET_CURRENT_CAMPAIGN(state, value) {
    state.currentCampaign = value;
  },

  SET_PREVIOUS_CAMPAIGN(state, value) {
    state.previousCampaign = value;
  },

  SET_DISTRIBUTOR(state, value) {
    state.distributor = value;
  },

  SET_STATE(state, value) {
    state.state = value;
  },

  SET_CROP(state, value) {
    state.crop = value;
  },

  SET_VARIETY(state, value) {
    state.variety = value;
  },

  SET_MONTH(state, value) {
    state.month = value;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
